// extracted by mini-css-extract-plugin
export default {"grid":"ProductDisplay_grid__CYsA8","headerText":"ProductDisplay_headerText__77ahg"};